import { Component, ViewChild, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ListComponent } from 'src/app/common/component/list.component';
import { MatPaginator } from '@angular/material/paginator';

@Component({
	selector: 'app-group-offer-list',
	templateUrl: './group-offer-list.component.html',
	styleUrls: ['./group-offer-list.component.css'],
	encapsulation: ViewEncapsulation.None,
})
export class GroupOfferListComponent extends ListComponent implements AfterViewInit {
	@Output() filtersClicked = new EventEmitter();
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;
	protected itemsBeforeDataLoad = 3;
	protected apiType = 'bag';
	protected apiUrl = 'offer/group_offer';
	protected filterValue = '';
	protected questionSubscription;
	displayedColumns: string[] = ['id', 'name', 'locations', 'groupProducts', 'date-range', 'edit'];
	showTable = true;
	matData = new MatTableDataSource<any>();
	locations: Array<any> = [];
	checkAll = false;
	filters;

	parameters = {
		yesno: [
			{ id: 1, name: 'Tak', value: true },
			{ id: 2, name: 'Nie', value: false },
		],
		products: [],
		locations: [],
		massAction: [
			{ name: 'StopSale', value: 'stopSale' },
			{ name: 'WWW', value: 'www' },
			{ name: 'MerlinX', value: 'merlinx' },
		],
	};
	action = {
		type: null,
		value: null,
	};

	protected lastClickedIndex = null;
	protected loadBefore(): void {
		this.bag.get('/product/?limit=9999', (result, error) => {
			this.parameters.products = result.results;
			this.loadData();
		});
		this.bag.get('/location/?limit=9999', (result, error) => {
			this.parameters.locations = result.results;
			this.loadData();
		});
	}

	ngAfterViewInit() {
		this.matData.sort = this.sort;
		this.matData.paginator = this.paginator;
	}

	protected sendData(ids: Array<number>) {
		const arrayToSend = ids.map((id) => {
			return this.submitBefore(this.matData.data.find((e) => e.id == id));
		});

		this.bag.put('/' + this.apiUrl + '/bulk_update/', arrayToSend, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.infobox.success('Zapisano');
			this.loader.hide();
		});
	}

	protected submitBefore(dataToSend) {
		dataToSend.groupProducts = dataToSend.groupProducts.map((obj) => {
			return {
				id: obj.id,
				product: obj.product.id,
			};
		});
		delete dataToSend.dateRange;
		return dataToSend;
	}

	protected convertData(result) {
		this.matData.data = result.results.map((obj) => {
			obj.locations = obj.locations.map((obj) => {
				const param = this.parameters.locations.find((e) => e.id == obj);
				if (param) {
					return param.name;
				}
			});

			obj.tooltipProducts = obj.groupProducts.map((obj) => {
				return obj.product.name;
			});
			obj.checked = false;
			return obj;
		});

		this.showTable = this.matData.data.length == 0 ? false : true;
	}

	protected selectAll(event) {
		this.matData.filteredData.forEach((row) => {
			row.checked = event.checked;
		});
	}
	checkMultipleSelection(event, index) {
		if (event.shiftKey) {
			if (this.lastClickedIndex == null) {
				// index może być 0, dlatego nie !this.lastClicked
				return;
			}
			event.preventDefault(); // wsparcie dla Chrome'a :P
			const array = this.matData.sortData(this.matData.data, this.matData.sort);
			this.range(this.lastClickedIndex, index).forEach((iter: number) => {
				array[iter].checked = true;
			});
		}
		this.lastClickedIndex = index;
	}
	massAction() {
		const checkedElements = this.matData.data.filter((element) => element.checked);
		let errors = '';

		if (!checkedElements.length) {
			errors += '<br>Nie wybrano żadnej grupy - pole wyboru z lewej strony';
		}
		if (!this.action.type) {
			errors += '<br>Nie wybrano kolumny';
		}
		if (this.action.value === null) {
			errors += '<br>Nie wybrano opcji, którą chcemy ustawić';
		}
		if (errors.length !== 0) {
			this.infobox.error(errors);
			return;
		}
		if (this.action.type == 'archived') {
			if (this.action.value) {
				this.askQuestion(
					'Przeniesienie terminu do archiwum, spowoduje zmianę kolumn StopSale, WWW, MerlinX oraz Promowany na NIE. Czy chcesz kontunuować?',
					() => {
						checkedElements.forEach((element) => {
							element[this.action.type] = this.action.value;
							element.stopSale = true;
							element.www = false;
							element.merlinx = false;
							element.promotion = false;
						});
						this.sendData(checkedElements);
						return;
					},
				);
			} else {
				this.askQuestion(
					'Wyciągnięcie terminu z archiwum, spowoduje zmianę kolumny StopSale na TAK. Czy chcesz kontunuować?',
					() => {
						checkedElements.forEach((element) => {
							element[this.action.type] = this.action.value;
							element.stopSale = false;
						});
						this.sendData(checkedElements);
						return;
					},
				);
			}
			return;
		}
		checkedElements.forEach((element) => {
			element[this.action.type] = this.action.value;
		});
		this.sendData(checkedElements);
	}
	protected range(first, sec) {
		const start = Math.min(first, sec);
		const len = Math.abs(first - sec) + 1;
		return Array.from({ length: len }, (x, i) => i + start);
	}
	refreshFilter() {
		if (this.filterValue.length < 3 && this.filterValue.length > 0) {
			return;
		}
		this.matData.filter = this.filterValue.trim().toLowerCase();
	}
	getChecked(filters, parameters = null): string {
		let checked = '';
		for (const key in filters) {
			if (typeof filters[key] == 'boolean') {
				checked += filters[key] ? '&' + key + '=1' : '&' + key + '=0';
				continue;
			}
			if (typeof filters[key] == 'number') {
				checked += '&' + key + '=' + filters[key];
				continue;
			}
			if (!filters[key]) {
				continue;
			}
			if (Array.isArray(filters[key])) {
				if (!parameters || !filters[key].length) {
					continue;
				}
				const objects = [];
				filters[key].forEach((obj, index) => {
					if (!obj) {
						return;
					}
					objects.push(obj);
				});
				checked += '&' + key + '=' + objects;
				continue;
			}
			checked += '&' + key + '=' + filters[key];
		}
		return checked.replace(/^&/, '');
	}

	askQuestion(question, callback) {
		this.question.ask(question, 'questionId');
		const questionSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'questionId') {
				return;
			}
			questionSubscription.unsubscribe();
			if (!result.result) {
				return;
			}
			callback();
		});
	}

	askQuestionArchive(event, element) {
		event.preventDefault();
		this.askQuestion('Zmiana tej opcji, wpłynie na wszystkie. Czy chcesz kontunuować?', () => {
			element.archived = !element.archived;
			if (element.archived) {
				element.stopSale = true;
				element.www = false;
				element.merlinx = false;
				element.promotion = false;
			} else {
				element.stopSale = false;
			}
			this.sendData([element]);
		});
	}

	removeDuplicates(locations) {
		return [...new Set(locations)];
	}
}
